import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { appHighlights, appSteps } from "@/mocks/home";

export default function AppSection() {
  return (
    <section id="app" className="scroll-mt-section bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal className="order-2 lg:order-1">
            <SectionHeading
              eyebrow="APP 介绍"
              title="茶杯狐影视 APP"
              subtitle="面向手机与平板的移动端应用，安装后即可进入内容列表，观看、收藏与进度都会跟随账号在各端保持一致。"
            />

            <ul className="mt-6 space-y-3">
              {appHighlights.map((item) => (
                <li key={item} className="flex gap-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 rounded-lg bg-secondary-100 border border-secondary-200 p-4 md:p-5">
              <p className="text-sm text-secondary-900 leading-relaxed">
                <span className="font-medium">提示：</span>
                请通过官方渠道获取安装包，并留意来源是否可信。安装前核对文件信息，避免使用来路不明的第三方文件。
              </p>
            </div>
          </Reveal>

          <Reveal delay={120} className="order-1 lg:order-2">
            <div className="relative mx-auto w-full max-w-sm">
              <div className="w-full aspect-[4/5] rounded-lg overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20product%20shot%20of%20a%20smartphone%20floating%20at%20a%20slight%20angle%20showing%20a%20minimal%20media%20app%20home%20screen%20in%20amber%20and%20cream%20tones%2C%20soft%20studio%20lighting%2C%20clean%20warm%20gradient%20background%2C%20subtle%20shadow%2C%20elegant%20editorial%20photography&width=900&height=1120&seq=app-phone-01&orientation=portrait"
                  alt="茶杯狐影视 APP 移动端界面示意"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -left-4 hidden sm:flex items-center gap-3 rounded-lg bg-background-50 border border-background-200 px-4 py-3 shadow-none">
                <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                  <i className="ri-smartphone-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">移动端优先</p>
                  <p className="text-xs text-foreground-500">手机 · 平板</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {appSteps.map((step, index) => (
            <Reveal key={step.step} delay={index * 80}>
              <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="font-heading text-3xl font-black text-primary-300">{step.step}</span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-900">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}